"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseQueryString = void 0;
var parseQueryString = function (search) {
    var searchQuery = search;
    if (searchQuery.startsWith('?'))
        searchQuery = searchQuery.substr(1);
    var params = searchQuery.split('&');
    var ret = {};
    params.forEach(function (param) {
        var keyVal = param.split('=', 2);
        if (keyVal.length > 1) {
            ret[keyVal[0]] = decodeURI(keyVal[1]);
        }
    });
    return ret;
};
exports.parseQueryString = parseQueryString;
